import Image from "next/image";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";

import { UtilitySectionData } from "../../types";

export default function UtilityCardImage({
  imageUrl,
  mobileImageUrl,
}: Pick<UtilitySectionData, "imageUrl" | "mobileImageUrl">) {
  const { isMobile } = useCheckIsMobile();

  return (
    <figure className="utility-card-image">
      <Image
        src={isMobile ? mobileImageUrl : imageUrl}
        width={isMobile ? 348 : 360}
        height={368}
        alt=""
        placeholder="blur"
        blurDataURL="/assets/images/landing/section-image-blur-data.png"
      />
    </figure>
  );
}
